import { c as _c } from "react/compiler-runtime";
import React from "react";
import style from "./TaxMenu.module.scss";
import { useRouterContext } from "../../../../context/RouterContext";
import Link from "next/link";
import { TaxPageFeature } from "../../../../pages/dashboard/TaxPage";
import { ErrorMessage } from "../../shared/ErrorMessage/ErrorMessage";
import { CustomLink } from "../../../shared/components/CustomLink/CustomLink";
const TaxMenu: React.FC<{
  choices: TaxPageFeature[];
  selected: TaxPageFeature | null;
  mobile?: boolean;
}> = t0 => {
  const $ = _c(15);
  const {
    choices,
    selected,
    mobile
  } = t0;
  const {
    taxPagePath
  } = useRouterContext();
  let containerStyles;
  if ($[0] !== mobile) {
    containerStyles = [style.menu];
    if (mobile) {
      containerStyles.push(style.menumobile);
    }
    $[0] = mobile;
    $[1] = containerStyles;
  } else {
    containerStyles = $[1];
  }
  if (!taxPagePath) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ErrorMessage>Missing tax page path to render menu</ErrorMessage>;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  const t1 = containerStyles.join(" ");
  let t2;
  if ($[3] !== choices || $[4] !== selected || $[5] !== taxPagePath) {
    let t3;
    if ($[7] !== selected || $[8] !== taxPagePath) {
      t3 = (c_0, i) => {
        let isSelected = false;
        if (selected && selected.slug.current == c_0.slug.current) {
          isSelected = true;
        } else {
          if (!selected && i == 0) {
            isSelected = true;
          }
        }
        return <li className={isSelected ? style["menu-selected"] : ""} key={c_0.slug.current}><CustomLink href={`${taxPagePath.join("/")}/${c_0.slug.current}`} scroll={false}>{c_0.title}</CustomLink></li>;
      };
      $[7] = selected;
      $[8] = taxPagePath;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = choices.filter(_temp).map(t3);
    $[3] = choices;
    $[4] = selected;
    $[5] = taxPagePath;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[10] !== t2) {
    t3 = <ul>{t2}</ul>;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t3) {
    t4 = <div className={t1}>{t3}</div>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
export default TaxMenu;
function _temp(c) {
  return c != null;
}